import React from 'react';
import { NavLink } from 'react-router-dom';

const Card = (props) => {
   return( 
      <> 
            <div className="col-md-4 col-10 mx-auto">
                <div className="card my-5">
                    <img src={props.imgsrc} className="card-img-top" alt="food"/>
                    <div className="card-body">
                        <h5 className="card-title font-weight-bold">{props.title}</h5>
                        <NavLink to="#" className="btn ">Go somewhere</NavLink>
                    </div>
                </div>
            </div>
      </>
   );
};

export default Card;